import FullScheduleScreen from '@/screens/full-schedule-screen/FullScheduleScreen'

export default function () {
  return <FullScheduleScreen />
}
